import { Button } from "@/components/ui/button";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";

export function SaveSettingsButton() {
  const { t } = useTranslation();

  const saveSettings = SettingsStore(state => state.saveSettings)
  const isLoading = SettingsStore(state => state.isLoading)
  const hasChanges = SettingsStore(state => state.hasChanges)

  return (
    <Button onClick={saveSettings} className="w-full p-0 h-9" disabled={isLoading || !hasChanges}>
      {t("settings.saveSettings")}
    </Button>
  );
}
